<h1 mat-dialog-title>Delete Project</h1>
<div mat-dialog-content>
  Are you sure want to delete this project?
</div>
<div class="dailog-footer-buttons">
  <button mat-raised-button [mat-dialog-close]="false" color="primary">No</button>
  <button mat-raised-button [mat-dialog-close]="true"  >Yes</button>
</div>